import React from 'react'
import Layout from '../components/Layout'
import { Link } from "gatsby"

export default function Prijava() {

    return (
        <Layout>
            <main className="container px-4 font-medium text-primary">
                <section className="my-20">
                    <h1 className="text-2xl xl:text-4xl">ZOT 2021 je TU! <Link to="/tekmovanje/2021"><span className="border-b-2 border-primary">Vstopna točka za tekmovalce</span>
          <svg className="w-5 h-5 inline" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg></Link></h1>
                    <img className="w-full h-auto my-5" src={'img/DSC00095.JPG'} alt="Taborniki na računalniku"/>
                </section>
                <section className="lg:flex">
                    <div className="lg:w-1/2 my-20 lg:pr-10">
                        <h2 className="text-2xl xl:text-4xl mb-2 xl:mb-6">#zot2021 iz udobja svoje občine!</h2>
                        <p className="text-lg lg:text-xl xl:text-2xl mb-5 lg:mb-10">Zaradi zdravstvene situacije, bo ZOT 2021 potekal <span className="font-mono">digitalno</span>.</p>
                        <Link to="/razpis/2021" className="text-lg lg:text-xl xl:text-2xl border-b-2 border-primary">Razpis 2021</Link>
                    </div>
                    <div className="lg:w-1/2 my-20 lg:pl-10">
                        <h2 className="text-2xl xl:text-4xl mb-2 xl:mb-6">Še ne poznaš ZOT-a?</h2>
                        <p className="text-lg lg:text-xl xl:text-2xl mb-5 lg:mb-10">ZOT je najboljše zimsko orientacijsko tekmovanje, ki ga organizira rod XI. SNOUB iz Maribora.</p>
                        <Link to="/tekmovanje" className="text-lg lg:text-xl xl:text-2xl border-b-2 border-primary">Več o tekmovanju</Link>
                    </div>
                </section>
            </main>
        </Layout>
    );
}